module.exports = __webpack_public_path__ + "img/google-docs.c5b59a88.svg";